import { createI13nNode } from 'react-i13n';

export default createI13nNode(
  'header',
  { bindClickEvent: false },
  {
    skipUtilFunctionsByProps: true,
  }
);
